import {createEvent} from "effector";

export const selectBuildingEv = createEvent()

export const resetChosenBuildingEv = createEvent()
